import {
  Box,
  Dialog,
  DialogContent,
  Divider,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import React, { forwardRef, useImperativeHandle, useState } from "react";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const TariffDescriptionDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);


  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setDialogData(params.row);
      setOpen(true);
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <Stack
        p={2}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography variant="h5" fontWeight={500}>
          Tariff Description
        </Typography>
      </Stack>
      <DialogContent dividers>
        <Typography gutterBottom>{dialogData?.description}</Typography>

        <Typography variant="h6" fontWeight={500}>
          Included
        </Typography>

        {dialogData?.other &&
          Object.entries(dialogData.other).map(([key, value], index) => (
            <Box item xs={12} key={index} display="flex" alignItems="center">
              <Stack
                flex={1}
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                border={"1px solid grey"}
                borderRadius={1}
                overflow={"hidden"}
              >
                <Box flex={1} p={1} bgcolor={"#ececec"}>
                  <Typography variant="body2" fontWeight={500}>
                    {key}
                  </Typography>
                </Box>
                <Divider orientation="vertical" flexItem />
                <Box flex={1} p={1}>
                  <Typography variant="body2">{value}</Typography>
                </Box>
              </Stack>
            </Box>
          ))}
      </DialogContent>
    </BootstrapDialog>
  );
});

export default TariffDescriptionDialog;
